module.exports = __webpack_public_path__ + "static/media/FooterPSIAssetsTemplet.7cc609e0.jpg";